import styled, { css } from 'styled-components'

const CustomHeader = styled.div`
${({ theme }) => {
        const { device } = theme;
        return css`        
            padding: 60px 0px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            text-align: center;
            max-width: 100vw;
            @media ${device.tabletM} {
                display: flex;
                text-align: start;
                justify-content: flex-start;
                align-items: flex-start;
            }
        `;
    }}
`;

const CustomLogo = styled.div`
${({ theme }) => {
        const { device } = theme;
        return css`
        padding-bottom: 30px;
        display: flex;
        justify-content: center;
        text-align: center;
        align-items: start;
        @media ${device.tabletM} {
            padding-bottom: 35px;
        }
    `;
    }}
`;

const LogoImg = styled.img`
${({ theme }) => {
        const { device } = theme;
        return css`
        width: 31.5px;
        height: 25px;
        margin-right: 9.5px;
        @media ${device.tabletM} {
            width: 50px;
            height: 40px;
        }
    `;
    }}
`;

const LogoTitle = styled.div`
${({ theme }) => {
        const { colors, fonts, device } = theme;
        return css`
        font-family: Noto Sans KR,sans-serif;
        font-style: normal;
        font-weight: ${fonts.weight.bold};
        line-height: 35px;
        color: ${colors.blue_4};
        font-size: 25px;
        width: 240px;
        & svg {
            fill: ${colors.blue_4};
        }
        @media ${device.tabletM} {
            font-size: 50px;
            width: 100%;
        }
    `;
    }}
`;

const SubTitle = styled.div`
${({ theme }) => {
        const { colors, device, fonts } = theme;
        return css`
        font-family: Noto Sans KR,
        font-weight: ${fonts.weight.medium};
        font-size: 16px;
        line-height: 18px;
        color: ${colors.blue_4};
        @media ${device.tabletM} {
            font-weight: 500;
            font-size: 35px;
            line-height: 30px;
            display: flex;
            width: 513px;
            justify-content: flex-end;
        }
    `;
    }}
`;

const Title = styled.div`
${({ theme }) => {
        const { colors, device, fonts } = theme;
        return css`
        font-family: Noto Sans KR,
        font-size: 16px;
        line-height: 18px;
        color: ${colors.blue_4};
        margin-top: 10px;
        font-weight: ${fonts.weight.bold};
        @media ${device.tabletM} {
            margin-top: 0px;
            font-size: 40px;
            line-height: 60px;
        }
    `;
    }}
`;

const styledComponents = { CustomLogo, CustomHeader, LogoImg, LogoTitle, Title, SubTitle };

export default styledComponents;